import React from "react";

export default function ReportIcon() {
  return (
    <svg
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M18 13.4988C19.1046 13.4988 20.0221 14.405 19.7787 15.4824C19.5367 16.5534 19.0995 17.5766 18.4832 18.4989C17.4943 19.979 16.0887 21.1325 14.4442 21.8137C12.7996 22.4949 10.99 22.6731 9.24419 22.3259C7.49836 21.9786 5.89472 21.1214 4.63604 19.8628C3.37737 18.6041 2.5202 17.0004 2.17294 15.2546C1.82567 13.5088 2.0039 11.6992 2.68509 10.0547C3.36628 8.41012 4.51983 7.00451 5.99987 6.01558C6.92216 5.39932 7.94542 4.96212 9.0164 4.72012C10.0938 4.47666 11 5.39423 11 6.4988V8.4988C11 11.2602 13.2386 13.4988 16 13.4988H18Z"
        fill="#A6B0CF"
      />
      <path
        d="M14 5.03307C14 3.08115 15.6408 1.43692 17.4442 2.18389C18.5361 2.63618 19.5282 3.29911 20.364 4.13484C21.1997 4.97057 21.8626 5.96272 22.3149 7.05465C23.0619 8.85799 21.4177 10.4988 19.4657 10.4988H18.5C16.0147 10.4988 14 8.48408 14 5.9988V5.03307Z"
        fill="#A6B0CF"
      />
    </svg>
  );
}
